"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceTradeInPanelLegalContentCMS = void 0;
var DeviceTradeInPanelLegalShortPathCMS_cms_1 = require("./DeviceTradeInPanelLegalShortPathCMS.cms");
var DeviceTradeInPanelLegalContentCMS = /** @class */ (function () {
    function DeviceTradeInPanelLegalContentCMS() {
        this.legalModalPath = [
            '/idpassets/fragment/legal/2005e/legalmodal/offers/wireline/checkout/tradeinlegallm.cmsfeed.js',
        ];
        this.legalShortPath = new DeviceTradeInPanelLegalShortPathCMS_cms_1.DeviceTradeInPanelLegalShortPathCMS();
    }
    return DeviceTradeInPanelLegalContentCMS;
}());
exports.DeviceTradeInPanelLegalContentCMS = DeviceTradeInPanelLegalContentCMS;
//# sourceMappingURL=DeviceTradeInPanelLegalContet.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceTradeInPanel/DeviceTradeInPanelLegalContet.cms.js
// module id = 2040
// module chunks = 8